import { commonjsGlobal as o } from "../../_virtual/_commonjsHelpers.js";
var e = typeof o == "object" && o && o.Object === Object && o, a = e;
export {
  a as _
};
//# sourceMappingURL=_freeGlobal.js.map
